import React from 'react'
import { Link } from 'react-router-dom'
import ListGroup from 'react-bootstrap/ListGroup'
import * as CONFIG from './_config'
import ls from "local-storage";

class About extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            policies:[],
        }
    };

    componentDidMount() {
        this.Policies();
        ls.set('redirectTo',window.location.href);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.location.pathname !== prevProps.location.pathname) {
            this.Policies();
            ls.set('redirectTo',window.location.href);
        }
    }

    Policies = ()=>{
      const policies = CONFIG.DATA.COMPANY_POLICIES;

        this.setState({
            policies: policies
        })

    }


    render() {
      const policy = this.state.policies;

    return (
        <div className="main-container full-width pt-5 mt-5">
        {   CONFIG.DATA.THEME === 2 ?
            <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb" style={{backgroundColor:'#f3ffd9'}}>
                <div className="container">
                    <div className="wrapper-breads">
                        <div className="wrapper-breads-inner">
                            <div className="breadscrumb-inner">
                                <h2 className="bread-title">Company Policies</h2>
                                <ol className="breadcrumb">
                                    <li>
                                        <a href={CONFIG.DATA.BASEPATH}>Home</a>  
                                    </li>
                                    <li>
                                        <span>Company Policies</span>
                                    </li> 
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            :
            <div className="title-breadcrumb">
                <div className="container">
                    <div className="title-breadcrumb-inner">
                        <header className="entry-header">
                            <h1 className="entry-title">Company Policies</h1>
                        </header>
                        <div className="breadcrumbs"><Link to="/">Home</Link><span className="separator">/</span><span>Company Policies</span></div>
                    </div>
                </div>
            </div>
        }

            <div className='container'>
                <div className="row abou_us_page">

                    <div className="vc_col-xs-12">
                        <div className="page-content default-page">

                            <article id="post-8436"
                                     className="post-8436 page type-page status-publish hentry">

                                <div className="entry-content">
                                    <div className="vc_row wpb_row vc_row-fluid">
                                        <div className="row-container" style={{/* marginLeft:'25%',*/ marginTop:'25px'}} >
                                           <div className="wpb_column vc_column_container vc_col-sm-10">
                                              <div className="vc_column-inner">
                                                 <div className="wpb_wrapper">
                                                     <div className="row">
                                                         <div className="col-md-12 text-left policy">
                                                             <ListGroup>
                                                                 {policy &&
                                                                    policy.map((value, index) => (
                                                                        <React.Fragment  key={index}>
                                                                            <ListGroup.Item className='border4x text-bold' key={index}><h5 className='entry-title'>{value.name}</h5></ListGroup.Item>
                                                                            <ListGroup variant="flush" >
                                                                                 {value.policie.map((val, key) => (
                                                                                     <ListGroup.Item className='border0x' key={key}>
                                                                                         {val.is_text ?
                                                                                             <Link to={'/company-policies/'+val.url}>
                                                                                                 <h6 className='text-black'>{val.name}</h6>
                                                                                             </Link>
                                                                                             :
                                                                                             <a href={val.url} target='_blank' rel="noopener noreferrer" ><h6 className='text-black' >{val.name}</h6></a>
                                                                                         }
                                                                                     </ListGroup.Item>
                                                                                 ))
                                                                                 }
                                                                            </ListGroup>
                                                                        </React.Fragment>
                                                                     ))
                                                                 }
                                                             </ListGroup>
                                                         </div>
                                                     </div>
                                                 </div>
                                              </div>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>   
                    </div>
                </div>
            </div>
        </div>
    )
    }
}
export default About;



